export const vehicles = [
  {
    id: "1",
    name: "Hyundai HB20",
    category: "Econômico",
    price: 179,
    originalPrice: 179,
    discount: 26,
    monthlyPrice: 1750,
    uberMonthlyPrice: 969,
    image: "https://storage.readdy-site.link/project_files/16c535c4-405d-4dba-9545-01fc00d6b7e7/dd7efd40-df1f-499f-852a-e2c931796780_befa3ef8-b87d-4bb1-9e4d-68cb08c8d3e7.jpg?v=653f882954ad6646b661f4dbd3a81ec6",
    seats: 5,
    doors: 4,
    transmission: "Manual",
    fuel: "Flex",
    ac: true,
    available: true,
    rating: 4.7,
    reviews: 128,
    features: ["Ar-condicionado", "Direção hidráulica", "Vidros elétricos", "Trava elétrica"],
    description: "Ideal para o dia a dia em Campinas. Econômico, confortável e fácil de estacionar.",
  },
  {
    id: "2",
    name: "Fiat Mobi",
    category: "Econômico",
    price: 90,
    originalPrice: 90,
    discount: 21,
    monthlyPrice: 1250,
    uberMonthlyPrice: 735,
    image: "https://storage.readdy-site.link/project_files/16c535c4-405d-4dba-9545-01fc00d6b7e7/53efa036-3134-44f5-9877-f7985a513c6a_WhatsApp-Image-2026-04-05-at-21.22.25.jpeg?v=4558a371f355a9c948be1bbd286ffd0f",
    seats: 5,
    doors: 4,
    transmission: "Manual",
    fuel: "Flex",
    ac: true,
    available: true,
    rating: 4.9,
    reviews: 87,
    features: ["Ar-condicionado", "Câmbio automático", "GPS", "Câmera de ré", "Teto solar"],
    description: "Perfeito para viagens e aventuras pela região de Campinas com conforto e segurança.",
  },
  {
    id: "3",
    name: "Onix",
    category: "Econômico",
    price: 219,
    originalPrice: 219,
    discount: 17,
    monthlyPrice: 2470,
    uberMonthlyPrice: 1129,
    image: "https://storage.readdy-site.link/project_files/16c535c4-405d-4dba-9545-01fc00d6b7e7/bb6be392-7a90-4774-87b2-dd0f6bf25252_WhatsApp-Image-2026-04-05-at-21.23.54.jpeg?v=72af24bee3659bac481475868757f2b6",
    seats: 5,
    doors: 4,
    transmission: "Automático",
    fuel: "Flex",
    ac: true,
    available: true,
    rating: 4.8,
    reviews: 203,
    features: ["Ar-condicionado", "Câmbio automático", "Multimídia", "Sensor de estacionamento"],
    description: "Elegância e conforto para executivos e viagens de negócios em Campinas.",
  },
  {
    id: "4",
    name: "Gol G6",
    category: "Econômico",
    price: 0,
    originalPrice: 0,
    discount: 0,
    monthlyPrice: 0,
    uberMonthlyPrice: 0,
    image: "https://storage.readdy-site.link/project_files/16c535c4-405d-4dba-9545-01fc00d6b7e7/72bd51e9-3aa5-496a-89e3-e05b4c3dda40_WhatsApp-Image-2026-04-05-at-21.26.11.jpeg?v=b9f6db3801a070639a33d58ccafcdb1b",
    seats: 5,
    doors: 4,
    transmission: "Manual",
    fuel: "Flex",
    ac: true,
    available: false,
    rating: 4.5,
    reviews: 64,
    features: ["Ar-condicionado", "Caçamba", "Direção elétrica", "Vidros elétricos"],
    description: "Versatilidade para trabalho e lazer. Ideal para quem precisa de carga e conforto.",
  },
  {
    id: "5",
    name: "Up",
    category: "Econômico",
    price: 125,
    originalPrice: 90,
    discount: 20,
    monthlyPrice: 1370,
    uberMonthlyPrice: 839,
    image: "https://storage.readdy-site.link/project_files/16c535c4-405d-4dba-9545-01fc00d6b7e7/c2fe5c4c-6e87-4dee-9ea9-67904c28041f_WhatsApp-Image-2026-04-05-at-21.25.26.jpeg?v=cc77c5912601b70d0304d103c55115af",
    seats: 5,
    doors: 4,
    transmission: "Manual",
    fuel: "Flex",
    ac: true,
    available: true,
    rating: 4.6,
    reviews: 91,
    features: ["Ar-condicionado", "7 lugares", "Multimídia", "Câmera de ré"],
    description: "Espaço para toda a família. 7 lugares com conforto para passeios em Campinas e região.",
  },
  {
    id: "6",
    name: "Fiat Argo",
    category: "Econômico",
    price: 149,
    originalPrice: 120,
    discount: 17,
    monthlyPrice: 10470,
    uberMonthlyPrice: 7329,
    image: "https://storage.readdy-site.link/project_files/16c535c4-405d-4dba-9545-01fc00d6b7e7/5e33b0a0-cdb9-4488-a062-e1a54a0e45ed_b0a75ab2-65e0-40d2-a019-f5836a8ccd8d.jpeg?v=e79e3b1ce07071dee9bea79e189a8aed",
    seats: 5,
    doors: 4,
    transmission: "Manual",
    fuel: "Flex",
    ac: true,
    available: true,
    rating: 5.0,
    reviews: 42,
    features: ["Ar-condicionado", "Câmbio automático", "Couro", "Teto solar", "GPS", "Som premium"],
    description: "Experiência premium para ocasiões especiais. Luxo e performance em Campinas.",
  },
];

export const specialOffers = [
  {
    id: "o1",
    vehicleId: "2",
    vehicle: "Fiat Mobi",
    category: "Econômico",
    discount: 30,
    price: 189,
    originalPrice: 270,
    validUntil: "2026-04-30",
    badge: "Mais Popular",
    image: "https://public.readdy.ai/ai/img_res/03aaec4d0afec37d26ea64511a68028a.jpg",
    highlight: true,
  },
  {
    id: "o2",
    vehicleId: "1",
    vehicle: "Hyundai HB20",
    category: "Econômico",
    discount: 25,
    price: 89,
    originalPrice: 119,
    validUntil: "2026-04-20",
    badge: "Melhor Custo",
    image: "https://readdy.ai/api/search-image?query=Hyundai%20HB20%20compact%20car%20white%20dynamic%20angle%20clean%20background%20professional%20automotive%20photography%20sharp%20details%20modern%20design&width=600&height=380&seq=o2&orientation=landscape",
    highlight: false,
  },
  {
    id: "o3",
    vehicleId: "6",
    vehicle: "BMW 320i",
    category: "Premium",
    discount: 20,
    price: 349,
    originalPrice: 436,
    validUntil: "2026-04-15",
    badge: "Luxo",
    image: "https://readdy.ai/api/search-image?query=BMW%20320i%20luxury%20sedan%20dark%20dynamic%20angle%20clean%20background%20professional%20automotive%20photography%20sharp%20details%20modern%20design&width=600&height=380&seq=o3&orientation=landscape",
    highlight: false,
  },
];

export const categories = [
  { id: "all", label: "Todos", icon: "ri-car-line" },
  { id: "Econômico", label: "Econômico", icon: "ri-car-line" },
  { id: "Sedan", label: "Sedan", icon: "ri-taxi-line" },
];
